t = require('app/scripts/views/internal/teacup-with-helpers')('confirm_merge')

module.exports = ->
  t.p ->
    t.text t.mustacheVar('text')

  t.ul '.pop-over-member-list.js-member'

  t.input '.js-confirm.full', { type: 'submit', value: t.mustacheVar('confirmText') }
